













import { Component, Vue } from 'vue-property-decorator'
import SensorForm from './SensorForm.vue'
import { Sensor, AddSensor } from '../store/sensor'
import { namespace } from 'vuex-class'
const sensorStore = namespace('sensor')
@Component({ components: { SensorForm } })
export default class AddSensorModal extends Vue {
  dialog = false
  @sensorStore.Action addSensor!: (sensor: AddSensor) => Promise<Sensor>
  @sensorStore.Action loadSensors!: () => void

  async add(sensor: AddSensor) {
    await this.addSensor(sensor)
    await this.loadSensors()
    this.dialog = false
  }
}
